enum RoutingStatus {
    resolve = 'RESOLVE',
    reject = 'REJECT',
    redirect = 'REDIRECT',
}

export { RoutingStatus };
export default RoutingStatus;
